module.exports = __webpack_public_path__ + "static/img/bg_neiye.d3cd95bd.png";